export default __webpack_public_path__ + "static/media/3536 spice rack F side.ae4c0a70.png";